import { useLocation, Outlet } from "react-router-dom";

/**
 * Обёртка над <Outlet>, которая перезапускает CSS-анимацию при смене роута.
 * Используется в BaseLayout вместо голого <Outlet />.
 */
export function AnimatedOutlet() {
  const { pathname } = useLocation();

  return (
    // key сбрасывает DOM-элемент при смене пути → CSS-анимация срабатывает заново
    <div key={pathname} className="h-full animate-page-in">
      <Outlet />
    </div>
  );
}
